import * as React from 'react';
import { IApiResponse } from '../services/Api';
import { AuthService, IAuthenticatedUser, ILoginData2fa } from '../services/AuthService';

interface IAuthProvider {
    user: IAuthenticatedUser | null;
    logOut: (callBack: any) => void;
    logIn: (loginData: ILoginData2fa) => Promise<IApiResponse>;
}

const AuthContext = React.createContext<IAuthProvider>({} as IAuthProvider);

export const AuthProvider = (props: any) => {
    const auth = useAuthProvider();
    
    return (
        <AuthContext.Provider value={auth}>
            { props.children }
        </AuthContext.Provider>
    )
}

export const useAuthProvider = () => {
    const localUser = localStorage.getItem("currentUser");
    const [user, setUser] = React.useState<IAuthenticatedUser | null>(localUser ? (JSON.parse(localUser)) : (null));

    const logOut = (callBack: any) => {
        AuthService.logOut(() => {
            localStorage.removeItem("currentUser");
            setUser(null);
            callBack();
        });
    };

    const logIn = async (loginData: ILoginData2fa) => {
        const response = await AuthService.logIn2fa(loginData);
        if (!response.error) {
            localStorage.setItem("currentUser", JSON.stringify(response.data));
            setUser(response.data);
        }
        return response;
    }

    React.useEffect(() => {
        const localUser = localStorage.getItem("currentUser");
        if (localUser) {
            const checkTokenIsValid = async () => {
                const isValidResponse = await AuthService.checkToken();
                if (!isValidResponse.error) {
                    setUser(JSON.parse(localUser));
                } else {
                    localStorage.removeItem("currentUser");
                    setUser(null);
                }
            }
            checkTokenIsValid();
        } else {
            setUser(null);
        }
    }, []);

    return {
        user,
        logOut,
        logIn
    };
}

export const useAuthContext = () => {
    return React.useContext(AuthContext);
}